import auth from "../api/auth";
import {ENUMS} from "../services/enums";

const state = () => ({
  verificationToken: null,
  billingPlans: [],
  billingSpecials: [],
  taxableStates: [],
  registrationForm: {
    billing_cycle: null,
    billing_plan: null,
    billing_special: null,
    billing_state: null,
    tax_rate: 0,
    coupon_code: null,
    paymentMethodId: null,

    company_name: null,
    street_address: null,
    city: null,
    state: null,
    postcode: null,
    long_in_business: null,
    how_many_deals: null,
    user_has_call_rail_account: null,
    user_have_used_automated_follow_up: null,

    first_name: null,
    last_name: null,
    email_address: null,
    phone_number: null,
    password: null,
    timezone: null,
  }
});

const getters = {
  getPlanInfo: (state) => (billingPlan) => {
    return state.billingPlans.find(plan => plan.type === billingPlan);
  },
};

const mutations = {
  setVerificationToken(state, token) {
    state.verificationToken = token;
  },
  setBillingPlans(state, plans) {
    state.billingPlans = plans;
  },
  setBillingSpecials(state, specials) {
    state.billingSpecials = specials;
  },
  setTaxableStates(state, states) {
    state.taxableStates = states;
  },
  setRegistrationFormProperty(state, payload) {
    state.registrationForm[payload.property] = payload.value;
  },
  setTaxRate(state, stateName) {
    const taxableState = state.taxableStates.find(taxableState => taxableState.state === stateName);
    if (taxableState) state.registrationForm.tax_rate = parseInt(taxableState.tax_rate);
  },
};

const actions = {
  getRegistrationData({commit, state}, verificationToken) {
    return auth.getAccountSetupData(verificationToken).then(response => {
      let verificationData = response.data;

      // Set registration form data from verification data
      commit('setRegistrationFormProperty', {property: 'billing_plan', value: verificationData.billing_plan});
      commit('setRegistrationFormProperty', {property: 'billing_cycle', value: verificationData.billing_cycle});
      commit('setRegistrationFormProperty', {property: 'billing_special', value: verificationData.billing_special});
      commit('setRegistrationFormProperty', {property: 'coupon_code', value: verificationData.coupon_code});
      commit('setRegistrationFormProperty', {property: 'first_name', value: verificationData.first_name});
      commit('setRegistrationFormProperty', {property: 'last_name', value: verificationData.last_name});
      commit('setRegistrationFormProperty', {property: 'phone_number', value: verificationData.phone_number});
      commit('setRegistrationFormProperty', {property: 'email_address', value: verificationData.email_address});

      // default plan and cycle
      if(!state.billing_plan) commit('setRegistrationFormProperty', {property: 'billing_plan', value: ENUMS.BillingPlanEnum.Pro.value});
      if(!state.billing_cycle) commit('setRegistrationFormProperty', {property: 'billing_cycle', value: ENUMS.BillingCycleEnum.Monthly.value});

      // Set extra info from verification data
      commit('setVerificationToken', verificationToken);
      commit('setBillingPlans', verificationData.current_billing_plans);
      commit('setBillingSpecials', verificationData.current_billing_specials);
      commit('setTaxableStates', verificationData.taxable_states);
    });
  },
};

const RegistrationStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default RegistrationStore;
